export default class Quiz {
    constructor() {
        this.TOTAL_QUESTIONS = 52;
        this.initializeElements();
        this.initializeState();
        this.initializeEventListeners();

        // Check if quiz was previously completed
        const quizCompleted = localStorage.getItem('quizCompleted');
        if (quizCompleted) {
            localStorage.removeItem('quizFormData');
            localStorage.removeItem('quizCompleted');
        } else {
            // this.loadSavedFormData();
        }
    }

    initializeElements() {
        this.form = document.querySelector('.quiz-form');
        if (!this.form) {
            console.error('Quiz form not found');
            return;
        }

        if (typeof window.quizData === 'undefined') {
            console.error('Quiz data not initialized');
            return;
        }

        this.sections = this.form.querySelectorAll('.quiz-section');
        this.progressBar = document.querySelector('.progress-bar');
        this.progressContainer = document.querySelector('.quiz-progress');

        if (!this.progressBar || !this.progressContainer) {
            console.error('Progress bar elements not found');
            return;
        }

        // Clear existing segments
        this.progressBar.innerHTML = '';

        for (let i = 0; i < this.TOTAL_QUESTIONS; i++) {
            const segment = document.createElement('div');
            segment.className = 'progress-segment';
            this.progressBar.appendChild(segment);
        }
    }

    initializeState() {
        this.currentStep = 100;
        this.totalSteps = this.sections.length;
        this.formData = new FormData();
        this.isSubmitting = false;
        this.answerHistory = [];
        this.questionPath = [];

        // Define question flow mapping
        this.questionFlow = {
            1: { low: 2, medium: 6, high: 6 },
            2: { low: 3, medium: 7, high: 7 },
            3: { low: 4, medium: 8, high: 8 },
            4: { low: 5, medium: 9, high: 9 },
            5: { low: 11, medium: 10, high: 10 },
            6: { low: 2, medium: 21, high: 21 },
            7: { low: 3, medium: 22, high: 22 },
            8: { low: 4, medium: 23, high: 23 },
            9: { low: 5, medium: 24, high: 24 },
            10: { low: 11, medium: 25, high: 25 },
            11: { low: 13, medium: 31, high: 31 },
            12: { low: 14, medium: 14, high: 'end' },
            13: { low: 15, medium: 32, high: 32 },
            14: { low: 16, medium: 16, high: 'end' },
            15: { low: 17, medium: 33, high: 33 },
            16: { low: 18, medium: 18, high: 'end' },
            17: { low: 19, medium: 34, high: 34 },
            18: { low: 20, medium: 20, high: 'end' },
            19: { low: 12, medium: 35, high: 35 },
            20: { low: 'end', medium: 'end', high: 'end' },
            21: { low: 2, medium: 26, high: 26 },
            22: { low: 3, medium: 27, high: 27 },
            23: { low: 4, medium: 28, high: 28 },
            24: { low: 5, medium: 29, high: 29 },
            25: { low: 11, medium: 30, high: 30 },
            26: { low: 2, medium: 2, high: 'end' },
            27: { low: 3, medium: 3, high: 'end' },
            28: { low: 4, medium: 4, high: 'end' },
            29: { low: 5, medium: 5, high: 'end' },
            30: { low: 11, medium: 11, high: 'end' },
            31: { low: 13, medium: 36, high: 36 },
            32: { low: 15, medium: 37, high: 37 },
            33: { low: 17, medium: 38, high: 38 },
            34: { low: 19, medium: 39, high: 39 },
            35: { low: 12, medium: 40, high: 40 },
            36: { low: 13, medium: 13, high: 12 },
            37: { low: 15, medium: 15, high: 14 },
            38: { low: 17, medium: 17, high: 16 },
            39: { low: 19, medium: 19, high: 18 },
            40: { low: 12, medium: 12, high: 20 }
        };

        // Initialize the quiz
        this.init();
    }

    init() {
        this.hideAllSections();
        // Show the first section (measurements section)
        const firstSection = this.form.querySelector('.quiz-section[data-step="100"]');
        if (firstSection) {
            firstSection.style.display = 'flex';
        }
        this.setupCheckboxGroups();
        this.setupRangeInputs();
        this.setupMedicationValidation();
        this.updateProgress();
    }

    hideAllSections() {
        this.sections.forEach(section => {
            section.style.display = 'none';
        });
    }

    showFirstSection() {
        const firstSection = this.form.querySelector('.quiz-section[data-step="100"]');
        if (firstSection) {
            firstSection.style.display = 'flex';
            firstSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    initializeEventListeners() {
        this.form.addEventListener('click', this.handleClick.bind(this));
        this.form.addEventListener('submit', this.handleSubmit.bind(this));
        this.form.addEventListener('change', this.handleChange.bind(this));
        document.addEventListener('keydown', this.handleKeydown.bind(this));
    }

    handleClick(e) {
        const target = e.target;
        if (target.matches('.next-button')) {
            this.nextStep();
        } else if (target.matches('.back-button')) {
            this.previousStep();
        } else if (target.matches('.start-button')) {
            this.handleStartButton(target);
        }
    }

    handleStartButton(target) {
        const currentBanner = target.closest('.quiz-section');
        const currentStep = parseInt(currentBanner.dataset.step);
        this.currentStep = currentStep + 1;
        this.showCurrentStep();
        this.updateProgress();
    }

    handleChange(e) {
        const target = e.target;
        if (target.matches('select, input[type="checkbox"]')) {
            this.handleSafetyChange(e);
            this.saveFormData();
        }
    }

    handleKeydown(e) {
        if (e.key === 'Enter' && !e.target.matches('textarea, input[type="text"]')) {
            e.preventDefault();
            this.nextStep();
        } else if (e.key === 'Escape') {
            this.previousStep();
        }
    }

    setupCheckboxGroups() {
        const checkboxGroups = this.form.querySelectorAll('.checkbox-group');
        checkboxGroups.forEach(group => {
            if (group.closest('#question-goals')) {
                this.setupGoalsCheckboxGroup(group);
            } else if (group.closest('#question-conditions')) {
                this.setupConditionsCheckboxGroup(group);
            } else if (group.closest('#question-physical-conditions')) {
                this.setupConditionsCheckboxGroup(group);
            }
        });
    }

    setupGoalsCheckboxGroup(group) {
        group.addEventListener('change', (e) => {
            if (e.target.matches('input[type="checkbox"]')) {
                const selectedCount = group.querySelectorAll('input[type="checkbox"]:checked').length;
                if (selectedCount > 3) {
                    e.target.checked = false;
                    this.showError(group, 'You can select a maximum of 3 options');
                } else {
                    this.clearError(group);
                }
            }
        });
    }

    setupConditionsCheckboxGroup(group) {
        group.addEventListener('change', (e) => {
            if (e.target.matches('input[type="checkbox"]')) {
                const selectedCount = group.querySelectorAll('input[type="checkbox"]:checked').length;
                if (selectedCount > 2) {
                    e.target.checked = false;
                    this.showError(group, 'You can select a maximum of 2 options');
                    return;
                }

                // Handle "none of the above" option
                if (e.target.value === 'none') {
                    if (e.target.checked) {
                        // Uncheck all other options when "none" is selected
                        group.querySelectorAll('input[type="checkbox"]:not([value="none"])').forEach(checkbox => {
                            checkbox.checked = false;
                        });
                    }
                } else {
                    // If any other option is selected, uncheck "none"
                    const noneCheckbox = group.querySelector('input[value="none"]');
                    if (noneCheckbox) {
                        noneCheckbox.checked = false;
                    }
                }

                this.clearError(group);
            }
        });
    }

    setupRangeInputs() {
        this.form.querySelectorAll('input[type="range"]').forEach(input => {
            const valueDisplay = input.nextElementSibling;
            input.addEventListener('input', () => {
                valueDisplay.textContent = input.value;
                this.saveFormData();
            });
            valueDisplay.textContent = input.value;
        });
    }

    setupMedicationValidation() {
        const medicationType = this.form.querySelector('#medication_type');
        const medicationName = this.form.querySelector('#medication_name');
        const medicationDetails = this.form.querySelector('.medication-details');
        const medicationRadios = this.form.querySelectorAll('input[name="medication[has_medication]"]');

        if (medicationRadios && medicationDetails) {
            medicationRadios.forEach(radio => {
                radio.addEventListener('change', () => {
                    const isMedication = radio.value === 'yes';
                    medicationDetails.style.display = isMedication ? 'block' : 'none';
                    medicationName.required = isMedication;
                    medicationType.required = isMedication;
                    if (!isMedication) {
                        medicationName.value = '';
                        medicationType.value = '';
                    }
                    this.saveFormData();
                });
            });
        }
    }

    handleSafetyChange(event) {
        const input = event.target;
        const warningDiv = input.closest('.form-group')?.querySelector('.warning-message');
        if (!warningDiv) return;

        const showWarning = {
            'psychiatric_meds': () => input.value === 'yes',
            'suicidal_thoughts': () => ['frequently', 'occasionally'].includes(input.value),
            'support_person': () => input.value === 'no'
        }[input.id]?.();

        warningDiv.style.display = showWarning ? 'flex' : 'none';
    }

    validateStep(step) {
        const section = this.form.querySelector(`[data-step="${step}"]`);
        if (!section) return false;

        this.clearErrors(section);
        return this.validateRequiredFields(section) &&
            this.validateCheckboxGroups(section) &&
            this.validateRadioGroups(section) &&
            this.validateMedication(section);
    }

    clearErrors(section) {
        section.querySelectorAll('.error-message').forEach(error => error.remove());
        section.querySelectorAll('.checkbox-group, .radio-group').forEach(group => {
            group.classList.remove('has-error');
        });
    }

    validateRequiredFields(section) {
        const requiredInputs = section.querySelectorAll('input[type="text"], input[type="email"], input[type="number"], select');
        let isValid = true;

        requiredInputs.forEach(input => {
            if (this.shouldSkipInput(input, section)) return;

            if (!input.value) {
                isValid = false;
                this.showError(input, 'This field is required');
            } else if (input.type === 'email' && !this.isValidEmail(input.value)) {
                isValid = false;
                this.showError(input, 'Please enter a valid email address');
            } else if (input.type === 'number' && !this.isValidNumber(input)) {
                isValid = false;
                this.showError(input, this.getNumberError(input));
            }
        });

        return isValid;
    }

    shouldSkipInput(input, section) {
        return input.closest('.radio-group') ||
            input.closest('.checkbox-group') ||
            (input.closest('.medication-details') &&
                section.querySelector('input[name="medication[has_medication]"]:checked')?.value === 'no');
    }

    isValidEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }

    isValidNumber(input) {
        const min = parseFloat(input.min);
        const max = parseFloat(input.max);
        const value = parseFloat(input.value);

        if (!isNaN(min) && value < min) return false;
        if (!isNaN(max) && value > max) return false;
        return true;
    }

    getNumberError(input) {
        const min = parseFloat(input.min);
        const max = parseFloat(input.max);
        const value = parseFloat(input.value);

        if (!isNaN(min) && value < min) return `Value must be at least ${min}`;
        if (!isNaN(max) && value > max) return `Value must be no more than ${max}`;
        return 'Invalid number';
    }

    validateCheckboxGroups(section) {
        const requiredCheckboxGroups = section.querySelectorAll('.checkbox-group[data-required="true"]');
        let isValid = true;

        requiredCheckboxGroups.forEach(group => {
            const checked = group.querySelectorAll('input[type="checkbox"]:checked').length > 0;
            if (!checked) {
                isValid = false;
                group.classList.add('has-error');
                this.showError(group, 'Please select at least one option');
            }

            const maxSelections = group.dataset.maxSelections;
            if (maxSelections) {
                const selectedCount = group.querySelectorAll('input[type="checkbox"]:checked').length;
                if (selectedCount > parseInt(maxSelections)) {
                    isValid = false;
                    group.classList.add('has-error');
                    this.showError(group, `Please select no more than ${maxSelections} options`);
                }
            }
        });

        return isValid;
    }

    validateRadioGroups(section) {
        const requiredRadioGroups = section.querySelectorAll('.radio-group');
        let isValid = true;

        requiredRadioGroups.forEach(group => {
            const checked = group.querySelector('input[type="radio"]:checked');
            if (!checked) {
                isValid = false;
                group.classList.add('has-error');
                this.showError(group, 'Please select an option');
            }
        });

        return isValid;
    }

    validateMedication(section) {
        const hasMedication = section.querySelector('input[name="medication[has_medication]"]:checked')?.value;

        if (hasMedication !== 'yes') return true;

        const medicationType = section.querySelector('select[name="medication[medication_type]"]');
        const medicationName = section.querySelector('input[name="medication[medication]"]');
        let isValid = true;

        if (!medicationType?.value) {
            isValid = false;
            this.showError(medicationType, 'Please select a medication type');
        }

        if (!medicationName?.value) {
            isValid = false;
            this.showError(medicationName, 'Please enter the medication name');
        }

        return isValid;
    }

    getNextQuestion(currentQuestion, answerValue) {
        const answerType = answerValue <= 2 ? 'low' : (answerValue === 3 ? 'medium' : 'high');
        return this.questionFlow[currentQuestion]?.[answerType] || 'end';
    }

    validateRestrictedConditions() {
        const restrictedMentalConditions = [
            'bipolar',
            'suicidal thoughts',
            'schizophrenia or other psychotic disorders'
        ];

        const restrictedPhysicalConditions = [
            'cardiovascular disease',
            'epilepsy or history of seizures',
            'renal failure',
            'hepatic failure',
            'diabetes mellitus',
            'autoimmune diseases'
        ];

        // Get selected conditions from both sections
        const mentalConditions = Array.from(document.querySelectorAll('#question-conditions input[type="checkbox"]:checked'))
            .map(input => input.value);
        const physicalConditions = Array.from(document.querySelectorAll('#question-physical-conditions input[type="checkbox"]:checked'))
            .map(input => input.value);

        // Skip validation for mental conditions if "none" is selected
        const skipMentalValidation = mentalConditions.includes('none');
        // Skip validation for physical conditions if "none" is selected
        const skipPhysicalValidation = physicalConditions.includes('none');

        // Count restricted conditions in each section (only if not skipped)
        const restrictedMentalCount = skipMentalValidation ? 0 : mentalConditions.filter(condition =>
            restrictedMentalConditions.includes(condition)
        ).length;
        const restrictedPhysicalCount = skipPhysicalValidation ? 0 : physicalConditions.filter(condition =>
            restrictedPhysicalConditions.includes(condition)
        ).length;

        // Check total restricted conditions across both sections
        const totalRestrictedCount = restrictedMentalCount + restrictedPhysicalCount;

        // Check for Stable Addiction (only if mental validation is not skipped)
        const hasStableAddiction = !skipMentalValidation && mentalConditions.includes('stable addiction');

        if (totalRestrictedCount >= 2) {
            alert("Based on your responses, there appear to be factors that may make psychedelic or ketamine-assisted therapy unsuitable or potentially unsafe for you at this time. For your safety and wellbeing, we cannot recommend proceeding with this approach. We strongly encourage you to consult with a qualified healthcare professional to explore alternative options that are better suited to your current needs");
            return false;
        } else if (totalRestrictedCount === 1 && !skipPhysicalValidation) {
            alert("Your responses indicate certain factors that may require extra care or medical oversight when considering psychedelic or ketamine-assisted therapy. While these are not absolute contraindications, we recommend discussing your situation with a trusted medical provider before moving forward, to ensure this approach is appropriate and safe for you");
            // No return false here, allowing the user to proceed
        }

        if (hasStableAddiction && !skipPhysicalValidation) {
            alert("Your responses indicate certain factors that may require extra care or medical oversight when considering psychedelic or ketamine-assisted therapy. While these are not absolute contraindications, we recommend discussing your situation with a trusted medical provider before moving forward, to ensure this approach is appropriate and safe for you");
            // No return false here, allowing the user to proceed
        }

        return true;
    }

    nextStep(event) {
        if (event) {
            event.preventDefault();
        }

        const currentStep = this.getCurrentStep();
        if (!currentStep) return false;

        if (currentStep.classList.contains('quiz-section--banner')) {
            this.currentStep++;
            this.showCurrentStep();
            this.updateProgress();
            return true;
        }

        if (!this.validateStep(this.currentStep)) {
            return false;
        }

        const currentQuestion = parseInt(currentStep.dataset.question);
        const currentStepNumber = parseInt(currentStep.dataset.step);

        // Check age when on age input section
        if (currentStep.id === 'question-age') {
            const ageInput = currentStep.querySelector('input[type="number"]');
            const age = parseInt(ageInput.value);
            if (age < 18) {
                alert("Based on your responses, there appear to be factors that may make psychedelic or ketamine-assisted therapy unsuitable or potentially unsafe for you at this time. For your safety and wellbeing, we cannot recommend proceeding with this approach. We strongly encourage you to consult with a qualified healthcare professional to explore alternative options that are better suited to your current needs");
                return false;
            } else if (age > 65) {
                alert("Your responses indicate certain factors that may require extra care or medical oversight when considering psychedelic or ketamine-assisted therapy. While these are not absolute contraindications, we recommend discussing your situation with a trusted medical provider before moving forward, to ensure this approach is appropriate and safe for you");
                // No return false here, allowing the user to proceed
            }
        }

        // Check BMI when on weight input section
        if (currentStep.id === 'question-height') {
            const heightInput = currentStep.querySelector('input[type="number"]');
            const weightInput = document.querySelector('#question-weight input[type="number"]');

            if (!weightInput.value || !heightInput.value) {
                return true; // Let the required field validation handle empty fields
            }

            const weight = parseFloat(weightInput.value);
            const height = parseFloat(heightInput.value) / 100; // Convert cm to m

            if (isNaN(weight) || isNaN(height) || height === 0) {
                return true; // Let the number validation handle invalid inputs
            }

            const bmi = weight / (height * height);
            console.log(bmi);

            // BMI categories that require medical consultation
            if (bmi < 16) {
                alert("Based on your responses, there appear to be factors that may make psychedelic or ketamine-assisted therapy unsuitable or potentially unsafe for you at this time. For your safety and wellbeing, we cannot recommend proceeding with this approach. We strongly encourage you to consult with a qualified healthcare professional to explore alternative options that are better suited to your current needs");
                return false;
            } else if (bmi >= 16 && bmi <= 17) {
                alert("Your responses indicate certain factors that may require extra care or medical oversight when considering psychedelic or ketamine-assisted therapy. While these are not absolute contraindications, we recommend discussing your situation with a trusted medical provider before moving forward, to ensure this approach is appropriate and safe for you");
                // No return false here, allowing the user to proceed
            } else if (bmi > 30) {
                alert("Your responses indicate certain factors that may require extra care or medical oversight when considering psychedelic or ketamine-assisted therapy. While these are not absolute contraindications, we recommend discussing your situation with a trusted medical provider before moving forward, to ensure this approach is appropriate and safe for you");
                // No return false here, allowing the user to proceed
            }
        }

        // Check for medication-substance interactions
        if (currentStep.id === 'question-medication') {
            const hasMedication = document.querySelector('input[name="medication[has_medication]"]:checked')?.value;
            if (hasMedication === 'yes') {
                const substanceInput = document.querySelector('#substance');
                const medicationTypeInput = document.querySelector('#medication_type');

                if (!substanceInput.value || !medicationTypeInput.value) {
                    return true; // Let the required field validation handle empty fields
                }

                const substance = substanceInput.value;
                const medicationType = medicationTypeInput.value;

                // Define dangerous combinations (block continuation)
                const dangerousCombinations = {
                    'MAOI': ['Ketamine', 'DMT', 'LSD', 'MDMA'],
                    'SSRI': ['DMT', 'MDMA'],
                    'TCAs': ['DMT', 'MDMA'],
                    'Mood Stabilizers': ['Ketamine', 'LSD', 'MDMA'],
                    'Stimulants': ['DMT', 'LSD', 'MDMA'],
                    'Drugs That Prolong the QT Interval': ['Ketamine', 'MDMA']
                };

                // Define warning combinations (allow continuation)
                const warningCombinations = {
                    'MAOI': ['Psilocybin', 'Ketamine', 'Cannabis'],
                    'SSRI': ['DMT', 'MDMA'],
                    'TCAs': ['DMT', 'MDMA'],
                    'Mood Stabilizers': ['DMT', 'Cannabis'],
                    'Stimulants': ['Ketamine', 'Cannabis'],
                    'Drugs That Prolong the QT Interval': ['Psilocybin', 'DMT', 'LSD', 'Cannabis'],
                    'Antihypertensive Medications': ['Psilocybin', 'Ketamine', 'DMT', 'LSD', 'MDMA', 'Cannabis'],
                    'Antiepileptic Drugs': ['Psilocybin', 'Ketamine', 'DMT', 'LSD', 'MDMA', 'Cannabis'],
                    'Benzodiazepines': ['Psilocybin', 'Ketamine', 'DMT', 'LSD', 'MDMA', 'Cannabis']
                };

                // Check dangerous combinations first
                for (const [medType, substances] of Object.entries(dangerousCombinations)) {
                    if (medicationType.includes(medType) && substances.includes(substance)) {
                        alert("Based on your responses, there appear to be factors that may make psychedelic or ketamine-assisted therapy unsuitable or potentially unsafe for you at this time. For your safety and wellbeing, we cannot recommend proceeding with this approach. We strongly encourage you to consult with a qualified healthcare professional to explore alternative options that are better suited to your current needs");
                        return false;
                    }
                }

                // Check warning combinations
                for (const [medType, substances] of Object.entries(warningCombinations)) {
                    if (medicationType.includes(medType) && substances.includes(substance)) {
                        alert("Your responses indicate certain factors that may require extra care or medical oversight when considering psychedelic or ketamine-assisted therapy. While these are not absolute contraindications, we recommend discussing your situation with a trusted medical provider before moving forward, to ensure this approach is appropriate and safe for you");
                        // No return false here, allowing the user to proceed
                    }
                }
            }
        }

        // Check for contraindicated conditions
        if (currentStep.id === 'question-conditions' || currentStep.id === 'question-physical-conditions') {
            if (!this.validateRestrictedConditions()) {
                return false;
            }
        }

        // Handle measurement section (steps 100-110)
        if (currentStepNumber >= 100 && currentStepNumber < 200) {
            if (this.currentStep < 111) {
                this.currentStep++;
                this.showCurrentStep();
                this.updateProgress();
            } else {
                // After measurements, show personality section
                this.currentStep = 200;
                this.showCurrentStep();
                this.updateProgress();
            }
            return true;
        }

        // Handle personality questions (steps 200+)
        if (!isNaN(currentQuestion)) {
            const selectedAnswer = currentStep.querySelector('input[name="Q' + currentQuestion + '"]:checked');
            if (!selectedAnswer) {
                this.showError(currentStep, 'Please select an answer before continuing.');
                return false;
            }

            const answerValue = parseInt(selectedAnswer.value);
            const nextQuestion = this.getNextQuestion(currentQuestion, answerValue);

            this.answerHistory.push({
                question: currentQuestion,
                answer: answerValue
            });

            if (nextQuestion === 'end') {
                // When question flow ends, go to email section
                const emailSection = this.form.querySelector('.quiz-section[data-step="300"]');
                if (emailSection) {
                    this.showStep(emailSection);
                } else {
                    this.handleSubmit(event);
                }
            } else {
                const nextStep = this.form.querySelector(`[data-question="${nextQuestion}"]`);
                if (nextStep) {
                    this.showStep(nextStep);
                }
            }
        }
    }

    previousStep() {
        if (this.currentStep <= 100) return;

        const currentSection = this.getCurrentStep();
        const currentStepNumber = parseInt(currentSection?.dataset.step);
        const questionNumber = parseInt(currentSection?.dataset.question);

        if (currentStepNumber === 300) {
            // If we're at email section, go back to last personality question
            const lastAnswer = this.answerHistory[this.answerHistory.length - 1];
            if (lastAnswer) {
                const previousSection = this.form.querySelector(`[data-question="${lastAnswer.question}"]`);
                if (previousSection) {
                    this.currentStep = parseInt(previousSection.dataset.step);
                    this.showCurrentStep();
                    this.updateProgress();
                }
            }
            return;
        }

        if (currentStepNumber >= 200) {
            // Handle personality section back navigation
            if (!isNaN(questionNumber)) {
                this.handleQuestionBack();
            } else {
                // If we're at personality banner (step 200), go back to last measurement
                this.currentStep = 111;
                this.showCurrentStep();
                this.updateProgress();
            }
            return;
        }

        // Handle measurement section back navigation
        this.currentStep--;
        this.showCurrentStep();
        this.updateProgress();
    }

    handleQuestionBack() {
        const previousAnswer = this.answerHistory.pop();
        if (previousAnswer) {
            const previousSection = this.form.querySelector(`[data-question="${previousAnswer.question}"]`);
            if (previousSection) {
                this.currentStep = parseInt(previousSection.dataset.step);
                const radioInput = previousSection.querySelector(`input[type="radio"][value="${previousAnswer.answer}"]`);
                if (radioInput) {
                    radioInput.checked = true;
                }
                this.showCurrentStep();
                this.updateProgress();
            }
        } else {
            // If no previous answer, go back to personality banner
            this.currentStep = 200;
            this.showCurrentStep();
            this.updateProgress();
        }
    }

    showStep(section) {
        this.hideAllSections();
        section.style.display = 'flex';
        this.currentStep = parseInt(section.dataset.step);
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        this.updateProgress();
    }

    getCurrentStep() {
        return this.form.querySelector(`.quiz-section[data-step="${this.currentStep}"]`);
    }

    showCurrentStep() {
        this.hideAllSections();
        const currentSection = this.form.querySelector(`.quiz-section[data-step="${this.currentStep}"]`);
        if (currentSection) {
            currentSection.style.display = 'flex';
            currentSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
            this.updateProgress();
        }
    }

    updateProgress() {
        if (!this.progressBar || !this.progressContainer) return;

        const segments = this.progressBar.querySelectorAll('.progress-segment');
        if (!segments.length) return;

        // Calculate current question number (excluding banners)
        const currentQuestion = Array.from(this.sections).filter(section =>
            !section.classList.contains('quiz-section--banner') &&
            parseInt(section.dataset.step) <= this.currentStep
        ).length;

        // Calculate filled segments based on total questions
        const filledSegments = Math.ceil((currentQuestion / this.TOTAL_QUESTIONS) * segments.length);

        // Update segment states
        segments.forEach((segment, index) => {
            segment.classList.toggle('filled', index < filledSegments);
        });

        // Hide progress bar on banner sections
        const currentSection = this.getCurrentStep();
        if (currentSection) {
            const isBanner = currentSection.classList.contains('quiz-section--banner');
            this.progressContainer.style.opacity = isBanner ? '0' : '1';
            this.progressContainer.style.visibility = isBanner ? 'hidden' : 'visible';
        }
    }

    showError(element, message) {
        const errorDiv = document.createElement('div');
        errorDiv.className = 'error-message';
        errorDiv.textContent = message;
        element.parentNode.insertBefore(errorDiv, element.nextSibling);
    }

    clearError(group) {
        const errorMessage = group.nextElementSibling;
        if (errorMessage && errorMessage.classList.contains('error-message')) {
            errorMessage.remove();
        }
    }

    saveFormData() {
        const formData = new FormData(this.form);
        localStorage.setItem('quizFormData', JSON.stringify(Object.fromEntries(formData)));
    }

    loadSavedFormData() {
        const savedData = localStorage.getItem('quizFormData');
        if (savedData) {
            const data = JSON.parse(savedData);
            Object.entries(data).forEach(([key, value]) => {
                const input = this.form.querySelector(`[name="${key}"]`);
                if (input) {
                    if (input.type === 'checkbox') {
                        input.checked = value === 'true';
                    } else if (input.type === 'radio') {
                        if (input.value === value) {
                            input.checked = true;
                            input.dispatchEvent(new Event('change'));
                        }
                    } else {
                        input.value = value;
                    }
                }
            });
        }
    }

    calculatePersonalityScores(formData) {
        const scores = {
            persona: {
                seeker: 0,
                analyst: 0,
                somatic: 0,
                achiever: 0,
                shadow_explorer: 0
            },
            ocean: {
                openness: 0,
                conscientiousness: 0,
                extraversion: 0,
                agreeableness: 0,
                neuroticism: 0
            }
        };

        const questionMapping = {
            // Persona scores
            1: { type: 'persona', trait: 'seeker' },
            2: { type: 'persona', trait: 'analyst' },
            3: { type: 'persona', trait: 'somatic' },
            4: { type: 'persona', trait: 'achiever' },
            5: { type: 'persona', trait: 'shadow_explorer' },
            6: { type: 'persona', trait: 'seeker' },
            7: { type: 'persona', trait: 'analyst' },
            8: { type: 'persona', trait: 'somatic' },
            9: { type: 'persona', trait: 'achiever' },
            10: { type: 'persona', trait: 'shadow_explorer' },
            21: { type: 'persona', trait: 'seeker' },
            22: { type: 'persona', trait: 'analyst' },
            23: { type: 'persona', trait: 'somatic' },
            24: { type: 'persona', trait: 'achiever' },
            25: { type: 'persona', trait: 'shadow_explorer' },
            26: { type: 'persona', trait: 'seeker' },
            27: { type: 'persona', trait: 'analyst' },
            28: { type: 'persona', trait: 'somatic' },
            29: { type: 'persona', trait: 'achiever' },
            30: { type: 'persona', trait: 'shadow_explorer' },

            // OCEAN scores
            11: { type: 'ocean', trait: 'openness' },
            12: { type: 'ocean', trait: 'openness' },
            13: { type: 'ocean', trait: 'conscientiousness' },
            14: { type: 'ocean', trait: 'conscientiousness' },
            15: { type: 'ocean', trait: 'extraversion' },
            16: { type: 'ocean', trait: 'extraversion' },
            17: { type: 'ocean', trait: 'agreeableness' },
            18: { type: 'ocean', trait: 'agreeableness' },
            19: { type: 'ocean', trait: 'neuroticism' },
            20: { type: 'ocean', trait: 'neuroticism' },
            31: { type: 'ocean', trait: 'openness' },
            32: { type: 'ocean', trait: 'conscientiousness' },
            33: { type: 'ocean', trait: 'extraversion' },
            34: { type: 'ocean', trait: 'agreeableness' },
            35: { type: 'ocean', trait: 'neuroticism' },
            36: { type: 'ocean', trait: 'openness' },
            37: { type: 'ocean', trait: 'conscientiousness' },
            38: { type: 'ocean', trait: 'extraversion' },
            39: { type: 'ocean', trait: 'agreeableness' },
            40: { type: 'ocean', trait: 'neuroticism' }
        };

        for (let i = 1; i <= 40; i++) {
            const answer = parseInt(formData.get(`Q${i}`));
            if (answer >= 4) {
                const mapping = questionMapping[i];
                if (mapping) {
                    scores[mapping.type][mapping.trait] += answer;
                }
            }
        }

        return scores;
    }

    handleSubmit(event) {
        event.preventDefault();

        if (this.isSubmitting) return;
        this.isSubmitting = true;

        const submitButton = this.form.querySelector('.submit-button');
        submitButton.disabled = true;
        submitButton.textContent = 'Processing...';

        const emailInput = this.form.querySelector('input[type="email"]');
        if (!this.validateEmail(emailInput)) {
            this.handleSubmitError(submitButton, emailInput);
            return;
        }

        try {
            const formData = new FormData(this.form);
            const quizData = this.prepareQuizData(formData);

            if (!this.validateQuizData(quizData)) {
                throw new Error('Invalid quiz data');
            }

            this.submitQuizData(quizData, submitButton);
        } catch (error) {
            this.handleError({
                message: error.message,
                code: 'validation_error'
            });
            this.isSubmitting = false;
            submitButton.disabled = false;
            submitButton.textContent = 'Submit Quiz';
        }
    }

    validateEmail(emailInput) {
        if (!emailInput || !emailInput.value) {
            this.showError(emailInput, 'Please enter your email address');
            return false;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(emailInput.value)) {
            this.showError(emailInput, 'Please enter a valid email address');
            return false;
        }

        return true;
    }

    prepareQuizData(formData) {
        const personalityScores = this.calculatePersonalityScores(formData);
        const hasMedication = formData.get('medication[has_medication]');

        return {
            'substance': formData.get('substance'),
            'experience': formData.get('experience'),
            'goal': formData.getAll('goal[]'),
            'condition': formData.getAll('condition[]'),
            'medication': {
                'has_medication': hasMedication,
                'medication': hasMedication === 'no' ? 'No' : formData.get('medication[medication]'),
                'medication_type': hasMedication === 'no' ? 'No' : formData.get('medication[medication_type]')
            },
            'persona_scores': personalityScores.persona,
            'ocean_scores': personalityScores.ocean,
            'country': formData.get('from'),
            'age': formData.get('age'),
            'sex': formData.get('sex'),
            'weight': formData.get('weight'),
            'height': formData.get('height'),
            'email': formData.get('email')
        };
    }

    validateQuizData(quizData) {
        const requiredFields = ['substance', 'experience', 'age', 'sex', 'weight', 'height', 'email'];
        for (const field of requiredFields) {
            if (!quizData[field]) {
                throw new Error(`Please fill in the ${field} field`);
            }
        }

        if (isNaN(quizData.age) || quizData.age < 0) {
            throw new Error('Please enter a valid age');
        }
        if (quizData.age < 18) {
            alert("Based on your responses, there appear to be factors that may make psychedelic or ketamine-assisted therapy unsuitable or potentially unsafe for you at this time. For your safety and wellbeing, we cannot recommend proceeding with this approach. We strongly encourage you to consult with a qualified healthcare professional to explore alternative options that are better suited to your current needs");
        }
        if (isNaN(quizData.weight) || quizData.weight <= 0) {
            throw new Error('Please enter a valid weight');
        }
        if (isNaN(quizData.height) || quizData.height <= 0) {
            throw new Error('Please enter a valid height');
        }

        return true;
    }

    submitQuizData(quizData, submitButton) {
        const data = {
            action: 'submit_quiz',
            nonce: window.quizData.nonce,
            data: JSON.stringify(quizData)
        };

        fetch(window.quizData.ajaxurl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams(data)
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
            })
            .then(result => {
                if (result.success) {
                    this.handleSuccess(result.data);
                } else {
                    this.handleError(result.data);
                }
            })
            .catch(error => {
                console.error('Error submitting quiz:', error);
                this.handleError({
                    message: error.message || 'Failed to submit quiz. Please try again.',
                    code: 'network_error'
                });
            })
            .finally(() => {
                this.isSubmitting = false;
                submitButton.disabled = false;
                submitButton.textContent = 'Submit Quiz';
            });
    }

    handleSubmitError(submitButton, emailInput = null) {
        this.isSubmitting = false;
        submitButton.disabled = false;
        submitButton.textContent = 'Submit Quiz';
        if (emailInput) {
            emailInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }

    getUserPath() {
        const path = [0];
        let currentQuestion = 1;

        this.answerHistory.forEach(answer => {
            path.push(parseInt(this.form.querySelector(`[data-question="${answer.question}"]`).dataset.step));
            currentQuestion = this.getNextQuestion(answer.question, answer.answer);
        });

        path.push(41);

        for (let i = 42; i <= 47; i++) {
            path.push(i);
        }

        return path;
    }

    handleSuccess(data) {
        if (data.response.status === 'IN_QUEUE' && data.response.id) {
            // Mark quiz as completed before redirecting
            localStorage.setItem('quizCompleted', 'true');
            window.location.href = `/quiz/${data.response.id}`;
            return;
        }
        this.showResponse(data);
    }

    handleError(error) {
        let responseContainer = document.querySelector('.quiz-response');
        if (!responseContainer) {
            responseContainer = document.createElement('div');
            responseContainer.className = 'quiz-response';
            this.form.parentNode.appendChild(responseContainer);
        }

        const errorHtml = `
            <div class="quiz-error">
                <h3>Error</h3>
                <p>${error.message || 'An error occurred while submitting the quiz.'}</p>
                ${error.code ? `<p class="error-code">Error code: ${error.code}</p>` : ''}
            </div>
        `;

        responseContainer.innerHTML = errorHtml;
        responseContainer.style.display = 'flex';
        responseContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    showResponse(data) {
        let responseContainer = document.querySelector('.quiz-response');
        if (!responseContainer) {
            responseContainer = document.createElement('div');
            responseContainer.className = 'quiz-response';
            this.form.parentNode.appendChild(responseContainer);
        }

        const successHtml = `
            <div class="quiz-success">
                <h3>Success</h3>
                <p>${data.message || 'Your quiz has been submitted successfully.'}</p>
            </div>
        `;

        responseContainer.innerHTML = successHtml;
        responseContainer.style.display = 'flex';
        responseContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
} 